import { render, staticRenderFns } from "./ModalInformativo.vue?vue&type=template&id=509b78c9&"
import script from "./ModalInformativo.vue?vue&type=script&lang=ts&"
export * from "./ModalInformativo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInformativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('509b78c9', component.options)
    } else {
      api.reload('509b78c9', component.options)
    }
    module.hot.accept("./ModalInformativo.vue?vue&type=template&id=509b78c9&", function () {
      api.rerender('509b78c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalInformativo.vue"
export default component.exports